import React, { useState } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment';

export default function CommonDatePicker({ selectedDates, estimateEndDate, estimateStartDate }) {
  const [selectedDays, changeDays] = useState(estimateEndDate ? [new Date(moment(estimateEndDate).format('YYYY'), moment(estimateEndDate).format('MM') - 1, moment(estimateEndDate).format('DD'))] : [])
  const [finalDays, setDays] = useState([])
  const handleDayClick = (day, { selected, disabled }) => {
    if (disabled) { return; }
    let dates = [...selectedDays]
    let final = [...finalDays]
    if (final.length === 0 && estimateEndDate) {
      final.push(moment(estimateEndDate).format('YYYY-MM-DD'))
    }
    if (selected) {
      const selectedIndex = dates.findIndex((selectedDay) => DateUtils.isSameDay(selectedDay, day));
      dates = [...dates.slice(0, selectedIndex), ...dates.slice(selectedIndex + 1)]
      final = [...final.slice(0, selectedIndex), ...final.slice(selectedIndex + 1)]
    } else {
      dates.push(day);
      final.push(moment(day).format('YYYY-MM-DD'))
    }
    changeDays(dates)
    setDays(final)
    selectedDates(final)
  }

  return (
    <div>
      <DayPicker
        disabledDays={[new Date(moment(estimateEndDate).format('YYYY'), moment(estimateEndDate).format('MM') - 1, moment(estimateEndDate).format('DD')),
          {
            after: new Date(moment(estimateEndDate).format('YYYY'), moment(estimateEndDate).format('MM') - 1, moment(estimateEndDate).format('DD')),
            before: new Date(moment(estimateStartDate).format('YYYY'), moment(estimateStartDate).format('MM') - 1, moment(estimateStartDate).format('DD')),
          }]}
        selectedDays={selectedDays}
        onDayClick={handleDayClick}
      />
    </div>
  )
}
